import { NavLink, Outlet } from "react-router-dom";
import { UserButton } from "@clerk/react";
import { LayoutDashboard, Radar, Building2, Target, Users, Send, Inbox, CalendarClock, FileText, Activity, BookOpen, Plug, BarChart3, Settings } from "lucide-react";
import { useMe } from "../lib/api";

const NAV = [
  ["/admin", "Overview", LayoutDashboard], ["/admin/discover", "Discover Leads", Radar], ["/admin/companies", "Companies", Building2],
  ["/admin/opportunities", "Opportunities", Target], ["/admin/contacts", "Contacts", Users], ["/admin/outreach", "Outreach", Send],
  ["/admin/inbox", "Email Inbox", Inbox], ["/admin/followups", "Follow-ups", CalendarClock], ["/admin/proposals", "Proposals", FileText],
  ["/admin/radar", "Technology Radar", Activity], ["/admin/skills", "Skills Catalogue", BookOpen], ["/admin/integrations", "Integrations", Plug],
  ["/admin/reports", "Reports", BarChart3], ["/admin/settings", "Settings", Settings],
];

export default function Layout() {
  const { me } = useMe();
  return (
    <div className="flex min-h-screen">
      <aside className="fixed inset-y-0 left-0 z-30 hidden w-64 flex-col bg-[#0F172A] text-slate-300 lg:flex">
        <div className="border-b border-white/10 px-5 py-5">
          <div className="flex items-center gap-2.5">
            <div className="relative h-8 w-8 rounded-md bg-blue-600">
              <div className="absolute inset-y-1.5 left-1/2 w-px -translate-x-1/2 bg-white/80" />
              <div className="absolute inset-x-1.5 top-1/2 h-px -translate-y-1/2 bg-white/40" />
            </div>
            <div>
              <div className="font-display text-sm font-extrabold tracking-tight text-white">DATAMERIDIAN AI</div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-slate-400">Lead Intelligence</div>
            </div>
          </div>
        </div>
        <nav className="flex-1 overflow-y-auto px-3 py-4">
          {NAV.map(([to, label, Icon]) => (
            <NavLink key={to} to={to} end={to === "/admin"} data-testid={`nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) => `mb-0.5 flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors duration-200 ${isActive ? "bg-blue-600 text-white" : "hover:bg-white/5 hover:text-white"}`}>
              <Icon size={16} strokeWidth={1.8} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-white/10 px-5 py-3 text-[11px] text-slate-500">Aligning Data. Empowering Decisions.</div>
      </aside>
      <div className="flex min-w-0 flex-1 flex-col lg:pl-64">
        <header className="sticky top-0 z-20 flex h-16 items-center justify-between border-b border-slate-200 bg-white px-6">
          <div className="flex items-center gap-3 text-sm text-slate-500">
            <span className="font-display font-semibold text-slate-900 lg:hidden">DATAMERIDIAN AI</span>
            <span className="hidden lg:inline">DataMeridian Consulting · Client Acquisition</span>
          </div>
          <div className="flex items-center gap-3">
            <span data-testid="current-role" className="rounded border border-slate-200 bg-slate-50 px-2 py-0.5 text-[11px] font-medium uppercase tracking-wide text-slate-600">{me?.role}</span>
            <UserButton />
          </div>
        </header>
        <nav className="flex gap-1 overflow-x-auto border-b border-slate-200 bg-white px-3 py-2 lg:hidden">
          {NAV.map(([to, label]) => (
            <NavLink key={to} to={to} end={to === "/admin"} className={({ isActive }) => `whitespace-nowrap rounded px-2.5 py-1 text-xs ${isActive ? "bg-blue-600 text-white" : "text-slate-600"}`}>{label}</NavLink>
          ))}
        </nav>
        <main className="mx-auto w-full max-w-[1500px] flex-1 p-6 lg:p-8"><Outlet /></main>
      </div>
    </div>
  );
}
